// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useLanguagesLevelsApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getLanguagesLevels = () => {
    return request("GET", `${API_STAGES_URL}/v1/languageslevels`)
  }

  return [
    requestState,
    payload,
    error,
    {
      getLanguagesLevels,
    },
  ]
}

export default useLanguagesLevelsApi
